import { useMemo, useState } from "react";
import { Check, Search } from "lucide-react";

const FAITH_NAMES = { christian: "Christian", muslim: "Muslim", jewish: "Jewish", hindu: "Hindu", buddhist: "Buddhist", spiritual: "Spiritual" };
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "");

export const Stat = ({ label, value, testId }) => (
  <div className="rounded-2xl border border-[#C86D51]/15 bg-white/70 p-5" data-testid={testId}>
    <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#7A665C]">{label}</p>
    <p className="mt-2 font-serif text-4xl text-[#2C221E]">{value}</p>
  </div>
);

export const AdminTable = ({ rows }) => {
  const [q, setQ] = useState("");
  const shown = useMemo(() => rows.filter((r) => `${r.email} ${r.invited_by ?? ""} ${r.faith} ${r.creator_code ?? ""}`.toLowerCase().includes(q.toLowerCase())), [rows, q]);
  return (
    <div className="rounded-[1.5rem] border border-[#C86D51]/15 bg-white/70">
      <div className="flex items-center gap-2 border-b border-[#C86D51]/15 px-4 py-3">
        <Search className="h-4 w-4 text-[#7A665C]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search email, faith or inviter" data-testid="admin-search-input"
          className="h-9 flex-1 bg-transparent text-sm text-[#2C221E] outline-none placeholder:text-[#8a766c]" />
        <span className="text-xs text-[#6B5A52]">{shown.length} shown</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-left text-sm" data-testid="admin-waitlist-table">
          <thead className="text-[11px] uppercase tracking-[0.16em] text-[#7A665C]">
            <tr>{["Spot", "Joined as", "Email", "Faith", "Confirmed", "Friends", "Invited by", "Creator", "Date"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
          </thead>
          <tbody>
            {shown.map((r) => (
              <tr key={r.email} className="border-t border-[#C86D51]/10 text-[#2C221E]" data-testid={`admin-row-${r.position}`}>
                <td className="px-4 py-3 font-serif text-lg">#{r.line_position}</td>
                <td className="px-4 py-3 text-[#6B5A52]">#{r.position}</td>
                <td className="px-4 py-3">{r.email}</td>
                <td className="px-4 py-3">{FAITH_NAMES[r.faith] ?? r.faith}</td>
                <td className="px-4 py-3">{r.confirmed ? <Check className="h-4 w-4 text-[#3F5E57]" /> : <span className="text-[#8a766c]">Pending</span>}</td>
                <td className="px-4 py-3">{r.referrals ?? 0}</td>
                <td className="px-4 py-3 text-[#6B5A52]">{r.invited_by ?? "—"}</td>
                <td className="px-4 py-3 font-mono text-xs text-[#9E4429]" data-testid={`admin-creator-cell-${r.position}`}>{r.creator_code ?? "—"}</td>
                <td className="px-4 py-3 text-[#6B5A52]">{fmtDate(r.created_at)}</td>
              </tr>
            ))}
            {!shown.length && <tr><td colSpan={8} className="px-4 py-10 text-center text-[#6B5A52]" data-testid="admin-empty">No sign-ups yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
